import React from 'react';
import { useNavigate } from 'react-router-dom';
import { openBannerCta } from '@/utils/bannerCta';
import { SButton } from '@/components/ui/atoms/SButton';
import { BannerDto } from '@/services/banner.service';
import './BannerCard.css';

interface BannerCardProps {
  banner: BannerDto;
}

export const BannerCard: React.FC<BannerCardProps> = ({ banner }) => {
  const navigate = useNavigate();
  const handleCta = () => openBannerCta(banner.ctaUrl, navigate);

  const effectiveImageUrl = banner.imageSignedUrl || banner.imageUrl;
  const isImageType = banner.type === 'image+text' && !!effectiveImageUrl;
  const hasLabel = !!banner.ctaLabel;
  const hasContent = !!(banner.headline || banner.body || hasLabel);

  const content = (
    <>
      {banner.headline && <h3 className="banner-card-headline">{banner.headline}</h3>}
      {banner.body && <p className="banner-card-body">{banner.body}</p>}
      {hasLabel && (
        <div className="banner-card-cta-wrapper">
          <SButton
            variant="primary"
            size="sm"
            label={banner.ctaLabel}
            onClick={handleCta}
          />
        </div>
      )}
    </>
  );

  return (
    <div className="banner-card">
      {isImageType && (
        <img
          src={effectiveImageUrl}
          alt={hasLabel ? '' : 'View offer'}
          className="banner-card-image"
          loading="lazy"
          {...(!hasLabel && banner.ctaUrl
            ? {
                onClick: handleCta,
                role: 'button' as const,
                tabIndex: 0,
                onKeyDown: (e: React.KeyboardEvent<HTMLImageElement>) => {
                  if (e.key === 'Enter' || e.key === ' ') handleCta();
                },
                style: { cursor: 'pointer' },
              }
            : {})}
        />
      )}
      {hasContent && (
        <div className={isImageType ? 'banner-card-glass' : 'banner-card-text-only'}>
          {content}
        </div>
      )}
    </div>
  );
};
